import { Area } from 'react-easy-crop'

export const getCroppedImg = (
  imageSrc: string,
  crop: Area,
  mimeType: 'image/jpeg' | 'image/png' = 'image/jpeg',
): Promise<Blob> => {
  return new Promise((resolve, reject) => {
    const image = new Image()

    image.src = imageSrc

    image.onload = () => {
      const canvas = document.createElement('canvas')

      canvas.width = crop.width
      canvas.height = crop.height

      const ctx = canvas.getContext('2d')

      if (!ctx) {
        reject(new Error('Failed to get crop context'))
        return
      }

      ctx.fillStyle = '#ffffff'
      ctx.fillRect(0, 0, canvas.width, canvas.height)

      ctx.drawImage(
        image,
        crop.x,
        crop.y,
        crop.width,
        crop.height,
        0,
        0,
        crop.width,
        crop.height,
      )

      canvas.toBlob((blob) => {
        if (blob) resolve(blob)
      }, mimeType)
    }

    image.onerror = () =>
      reject(new Error('Erro ao carregar a imagem para crop.'))
  })
}
